import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";

import scannerSchema from "../../schemas/scanner.schema";
import { validate } from "../../utils/ValidationHelpers";
import ValidationError from "../Shared/ValidationError";

const ScannerSettingsForm = ({
    scannerSettings,
    setScannerSettings,
    isFormSubmitted,
    setIsFormValid,
    disabled = false,
}) => {
    const { t } = useTranslation();

    const [error, setError] = useState({});

    useEffect(() => {
        validate(
            scannerSettings,
            scannerSchema.ScannerSettingsSchema,
            setIsFormValid,
            setError
        );
    }, [scannerSettings]);

    const handleOnChange = (e) => {
        setScannerSettings((prevSettings) => ({
            ...prevSettings,
            [e.target.name]: e.target.value,
        }));
    };

    const fields = [
        {
            label: t("interpolation"),
            value: (
                <>
                    <input
                        onChange={handleOnChange}
                        value={scannerSettings?.interpolation || ""}
                        name="interpolation"
                        type="text"
                        className="input-element"
                        disabled={disabled}
                    />
                    <ValidationError
                        errorMessage={isFormSubmitted && error.interpolation}
                    />
                </>
            ),
        },
        {
            label: t("apodization"),
            value: (
                <>
                    <input
                        name="apodization"
                        value={scannerSettings?.apodization || ""}
                        onChange={handleOnChange}
                        className="input-element"
                        disabled={disabled}
                    />
                    <ValidationError
                        errorMessage={isFormSubmitted && error.apodization}
                    />
                </>
            ),
        },
        {
            label: t("fftPoints"),
            value: (
                <>
                    <input
                        onChange={handleOnChange}
                        value={scannerSettings?.FFTPoints || ""}
                        name="FFTPoints"
                        type="text"
                        className="input-element"
                        disabled={disabled}
                    />
                    <ValidationError
                        errorMessage={isFormSubmitted && error.FFTPoints}
                    />
                </>
            ),
        },
        {
            label: t("gain"),
            value: (
                <>
                    <input
                        name="gain"
                        value={scannerSettings?.gain || ""}
                        onChange={handleOnChange}
                        className="input-element"
                        disabled={disabled}
                    />
                    <ValidationError
                        errorMessage={isFormSubmitted && error.gain}
                    />
                </>
            ),
        },
        {
            label: t("scanTime"),
            value: (
                <>
                    <input
                        onChange={handleOnChange}
                        value={scannerSettings?.scanTime || ""}
                        name="scanTime"
                        type="text"
                        className="input-element"
                        disabled={disabled}
                    />
                    <ValidationError
                        errorMessage={isFormSubmitted && error.scanTime}
                    />
                </>
            ),
        },
    ];

    const renderFields = () => {
        return (
            fields &&
            fields.map((field, index) => (
                <div
                    className={`input-group ${
                        error[field.name] && isFormSubmitted
                            ? "invalid-warning-input"
                            : ""
                    }`}
                    key={index}
                >
                    <label className="uppercase required">{field.label}</label>
                    {field.value}
                </div>
            ))
        );
    };

    return (
        <>
            <div className="settings-modal flex items-start justify-between">
                <div className="main-customer-form-inputs w-full grid-3-cols">
                    {renderFields()}
                </div>
            </div>
        </>
    );
};

export default ScannerSettingsForm;
